import { ApiService } from "./AbstractApiService";
import { IPageModel } from "@/interfaces/iPageModel";
import {
  ISaveFormServer,
  FormSectionRowColumnModel,
  IinProcessForm,
} from "@/views/formBuilder/components/dynamicValidation";
import { IFormSections } from "@/interfaces/iForm";
import API from "./handlers/base.service";
import axios, { CancelTokenStatic } from "axios";

export class SectionDesignAPI extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: SectionDesignAPI | null;
  public static cancelToken: CancelTokenStatic | null = null;
  constructor() {
    super("forms/sections");
  }
  public async getSectionDetail(sectionId): Promise<IFormSections> {
    return this.get(`${sectionId}`).then((response) => response.data);
  }

  public async saveFormDesign(
    sectionId: string
  ): Promise<IPageModel<ISaveFormServer>> {
    return API.post(`forms/sections/publish/${sectionId}`).then(
      (response) => response.data
    );
  }
  public async updateFormDesign(
    payload: ISaveFormServer[],
    sectionId: string,
    saveAsTemplate: boolean
  ): Promise<IPageModel<ISaveFormServer>> {
    return this.put(
      `formDesign/${sectionId}?template=${saveAsTemplate}`,
      payload
    ).then((response) => response.data);
  }

  public async getFormDesign(sectionId: string): Promise<ISaveFormServer[]> {
    return await API.get(`forms/sectionRows?sectionId=${sectionId}`).then(
      (response) => response.data
    );
  }

  public async getFormDesignPreview(
    sectionId: string,
    viewport?: string,
    formId?: string,
    siteId?: string
  ): Promise<any> {
    return API.get(
      `forms/sectionRows/preview?sectionId=${sectionId}&formDefinitionId=${
        formId == undefined ? "" : formId
      }&siteId=${siteId == undefined ? "" : siteId}`,
      {
        headers: {
          screenSize: viewport,
        },
      }
    ).then((response) => response.data);
  }
  public async saveFormRow(payload: ISaveFormServer): Promise<ISaveFormServer> {
    if (payload.webId) {
      return API.put(`forms/sectionRows/${payload.webId}`, payload).then(
        (response) => response.data
      );
    }
    return API.post(`forms/sectionRows`, payload).then(
      (response) => response.data
    );
  }
  public async saveFormColumn(
    payload: FormSectionRowColumnModel
  ): Promise<FormSectionRowColumnModel> {
    if (payload.webId) {
      return API.put(`forms/sectionRowColumns/${payload.webId}`, payload).then(
        (response) => response.data
      );
    }
    return API.post(`forms/sectionRowColumns`, payload).then(
      (response) => response.data
    );
  }
  public async getFormInprocess(
    sectionId: string
  ): Promise<IinProcessForm | null> {
    return API.get(`forms/inProcess/latest?sectionId=${sectionId}`).then(
      (response) => response.data
    );
  }
  public async patchFormInprocess(
    sectionId: number,
    data: ISaveFormServer[]
  ): Promise<IinProcessForm | null> {
    if (this.cancelToken) {
      this.cancelToken.cancel();
    }
    this.cancelToken = axios.CancelToken.source();
    return API.patch(
      `forms/inProcess/${sectionId}`,
      {
        data: { formSectionRowModels: data },
      },
      {
        cancelToken: this.cancelToken.token,
      }
    ).then((response) => response.data);
  }
  public async postFormInprocess(
    sectionId: string,
    data: ISaveFormServer[]
  ): Promise<IinProcessForm | null> {
    return API.post(`forms/inProcess`, {
      data: { formSectionRowModels: data },
      formSectionId: sectionId,
      status: "IN_PROCESS",
    }).then((response) => response.data);
  }
  public async deleteFormInprocess(formId: number): Promise<void> {
    return API.delete(`forms/inProcess/${formId}`).then(
      (response) => response.data
    );
  }
  public async postIsTemplate(
    sectionId: string,
    data: ISaveFormServer[],
    isTemplate: boolean
  ): Promise<IinProcessForm | null> {
    if (isTemplate) {
      return API.post(`forms/sectionTemplates`, {
        data: { formSectionRowModels: data },
        formSectionId: sectionId,
        status: "ACTIVE",
      }).then((response) => response.data);
    } else {
      return API.delete(`forms/sectionTemplates/section/${sectionId}`).then(
        (response) => response.data
      );
    }
  }
}
